The type of the replay.

Currently, two codes are defined:

- `RangeReplayRequest` which corresponds to the `WebhookSubscriptionReplayByRangeRequest` type.
- `IdReplayRequest` which corresponds to the `WebhookSubscriptionReplayByIdRequest` type.
